import { api } from './client'
import type { components } from './generated/schema'

// Frontend-safe view of the camera integration account: the password is never
// returned, has_password only reports whether one is stored.
export type GrowerCameraSettings = components['schemas']['GrowerCameraSettings']

export type UpdateGrowerCameraSettingsRequest =
    components['schemas']['UpdateGrowerCameraSettingsRequest']

export const growerCameraSettingsApi = {
    get: () => api.get<GrowerCameraSettings>('/grower-camera/settings'),
    update: (data: UpdateGrowerCameraSettingsRequest) =>
        api.put<GrowerCameraSettings>('/grower-camera/settings', data),
}
